import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Card,
  FormInput,
  FormInputText,
  FormInputTextArea,
  Row,
  Col,
  DetailList,
  ButtonContainer,
  Button,
  Alert,
  ContentSectionBlock
} from 'camino-react'

import { cloudhelpPatch, cloudhelpPost } from 'Utilities/CloudHelp'
import AssociatedQuestionContent from 'Components/Surveys/Questions/AssociatedQuestionContent'

class SurveyForm extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      submitButton: {
        text: 'Save Survey',
        disabled: false
      },
      errors: [],
      questionErrors: [],
      fields: {
        title: props.survey.title,
        description: props.survey.description,
        subject: props.survey.subject,
        definition: props.survey.definition
      },
      survey: props.survey,
      currentQuestions: props.survey.questions,
      associatedQuestionSelections: [],
      unassociatedQuestionSelections: [],
      createQuestionSelections: []
    }

    this.handleFieldValue = this.handleFieldValue.bind(this)
    this.submit = this.submit.bind(this)
    this.setQuestion = this.setQuestion.bind(this)
    this.removeQuestion = this.removeQuestion.bind(this)
    this.addQuestion = this.addQuestion.bind(this)
    this.addCreateQuestion = this.addCreateQuestion.bind(this)
    this.handleQuestionFieldValue = this.handleQuestionFieldValue.bind(this)
    this.removeQuestionSelection = this.removeQuestionSelection.bind(this)
    this.onAnswerChange = this.onAnswerChange.bind(this)
    this.removeAnswerOption = this.removeAnswerOption.bind(this)
    this.addAnswerOption = this.addAnswerOption.bind(this)
  }

  onAnswerChange (questionIndex, value, index) {
    this.setState((prevState) => {
      const { createQuestionSelections } = prevState

      createQuestionSelections[questionIndex].answers[index] = value

      return { createQuestionSelections }
    })
  }

  setQuestion (index, questionId) {
    this.setState((prevState) => {
      const { associatedQuestionSelections: previous } = prevState

      const associatedQuestionSelections = [...previous]
      associatedQuestionSelections[index] = questionId

      return { associatedQuestionSelections }
    })
  }

  submit () {
    this.setState({
      submitButton: {
        text: 'Saving Survey',
        disabled: true
      },
      errors: []
    })

    const {
      fields,
      unassociatedQuestionSelections,
      survey,
      associatedQuestionSelections,
      createQuestionSelections
    } = this.state

    const { paths } = this.props

    const { requestPath } = paths

    const {
      title,
      description,
      subject,
      definition
    } = fields

    const postData = {
      survey: {
        title,
        description,
        subject,
        definition,
        question_ids: [...associatedQuestionSelections, ...unassociatedQuestionSelections],
        questions: createQuestionSelections
      }
    }

    const request = _.isNull(survey.id) ? cloudhelpPost : cloudhelpPatch

    request(requestPath, postData)
      .then(({ data: { survey: { href } } }) => {
        this.setState({
          submitButton: {
            text: 'Survey Saved',
            disabled: true
          }
        })

        window.location.href = href
      })
      .catch(({ response: { data: { survey: { errors }, questions: questionErrors, full_error_messages: fullErrorMessages } } }) => {

        this.setState({
          questionErrors,
          errors,
          submitButton: {
            text: 'Save Survey',
            disabled: false
          },
          alert: {
            type: 'error',
            title: 'Please correct the errors below.',
            messages: fullErrorMessages
          }
        })
      })
  }

  removeQuestion (questionId) {
    this.setState((prevState) => {
      const {
        currentQuestions: previousQuestions,
        unassociatedQuestionSelections
      } = prevState

      const currentQuestions = _.remove(previousQuestions, ({ id }) => (id === questionId))
      unassociatedQuestionSelections.push(questionId)

      return { currentQuestions, unassociatedQuestionSelections }
    })
  }

  addQuestion (questionId) {
    this.setState((prevState) => {
      const { associatedQuestionSelections: previous } = prevState

      const associatedQuestionSelections = [...previous, questionId]

      return { associatedQuestionSelections }
    })
  }

  addCreateQuestion (index) {
    this.setState((prevState) => {
      const { createQuestionSelections: previous } = prevState

      const createQuestionSelections = [...previous, { question: '', question_type: 'text', answers: [] }]

      return { createQuestionSelections }
    })
  }

  removeAnswerOption (questionIndex, answerIndex) {
    this.setState((prevState) => {
      const { createQuestionSelections } = prevState
      const previousQuestion = createQuestionSelections[questionIndex]
      const previousAnswers = previousQuestion.answers
      const newAnswers = [...previousAnswers]

      newAnswers.splice(answerIndex, 1)
      const remainingAnswers = newAnswers

      previousQuestion.answers = remainingAnswers
      const newQuestion = Object.assign({}, previousQuestion, { answers: remainingAnswers })

      const newQuestionSelections = [...createQuestionSelections]
      newQuestionSelections[questionIndex] = newQuestion

      return { createQuestionSelections: newQuestionSelections }
    })
  }

  addAnswerOption (questionIndex) {
    this.setState((prevState) => {
      const { createQuestionSelections } = prevState
      const previousQuestion = createQuestionSelections[questionIndex]
      const previousAnswers = previousQuestion.answers

      const newAnswers = [...previousAnswers]
      newAnswers.push('')

      const newQuestion = Object.assign({}, previousQuestion, { answers: newAnswers })
      const newQuestionSelections = [...createQuestionSelections]
      newQuestionSelections[questionIndex] = newQuestion

      return { createQuestionSelections: newQuestionSelections }
    })
  }

  handleFieldValue (key, value) {
    this.setState((prevState) => {
      const { fields } = prevState

      const newFields = Object.assign({}, fields, { [key]: value })

      return { fields: newFields }
    })
  }

  handleQuestionFieldValue (key, value, index) {
    this.setState((prevState) => {
      const { createQuestionSelections } = prevState

      createQuestionSelections[index][key] = value

      return { createQuestionSelections }
    })
  }

  removeQuestionSelection (index) {
    this.setState((prevState) => {
      const { createQuestionSelections } = prevState

      createQuestionSelections.splice(index, 1)

      return { createQuestionSelections }
    })
  }

  render () {
    const {
      handleFieldValue,
      addQuestion,
      removeQuestion,
      setQuestion,
      addCreateQuestion,
      removeAnswerOption,
      addAnswerOption,
      handleQuestionFieldValue,
      removeQuestionSelection,
      onAnswerChange,
      submit
    } = this

    const { questions, questionTypes } = this.props

    const {
      fields,
      alert,
      submitButton: {
        text: submitText,
        disabled: submitDisabled
      },
      errors,
      questionErrors,
      survey,
      associatedQuestionSelections,
      currentQuestions,
      createQuestionSelections
    } = this.state

    const textArea = key => ({
      value: fields[key],
      onValue: value => handleFieldValue(key, value),
      errors: errors[key],
      rows: 5
    })

    return (
      <Row>
        <Col>
          { alert && alert.messages && (
            <Alert type={alert.type} title={alert.title}>
              {alert.messages}
            </Alert>
          ) }
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Title and description',
                    content: 'The title and description of this survey, purely for internal purposes'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card allowOverflow>
                <ContentSectionBlock>
                  <FormInput label="Title">
                    <FormInputText
                      {...textArea('title')}
                    />
                  </FormInput>
                  <FormInput label="Description">
                    <FormInputTextArea
                      {...textArea('description')}
                    />
                  </FormInput>
                </ContentSectionBlock>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Email details',
                    content: 'The subject and content of the survey email sent to clients.'
                  }
                ]}
              />
            </Col>
            <Col>
              <Card>
                <FormInput label="Survey subject">
                  <FormInputText
                    {...textArea('subject')}
                  />
                </FormInput>
                <FormInput label="Content">
                  <FormInputTextArea
                    {...textArea('definition')}
                  />
                </FormInput>
              </Card>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <DetailList
                list={[
                  {
                    title: 'Questions',
                    content: 'Questions that will be asked on the survey'
                  },
                  {
                    content: (
                      <small>
                        <DetailList
                          list={[
                            {
                              title: 'Select (Single Choice)',
                              content: 'This will generate a select box / dropdown that can only have one chosen option.'
                            },
                            {
                              title: 'Select (Multi Choice)',
                              content: 'This will generate a select box / dropdown that can have multiple chosen options.'
                            },
                            {
                              title: 'Text',
                              content: 'This will generate a free text field.'
                            },
                            {
                              title: 'Range',
                              content: 'This will generate radio buttons that are between the range provided.'
                            }
                          ]}
                        />
                      </small>
                    )
                  }
                ]}
              />
            </Col>
            <Col>
              <AssociatedQuestionContent
                addQuestion={addQuestion}
                removeQuestion={removeQuestion}
                setQuestion={setQuestion}
                associatedQuestionSelections={associatedQuestionSelections}
                survey={survey}
                currentQuestions={currentQuestions}
                questions={questions}
                createQuestionSelections={createQuestionSelections}
                addCreateQuestion={addCreateQuestion}
                removeAnswerOption={removeAnswerOption}
                handleQuestionFieldValue={handleQuestionFieldValue}
                removeQuestionSelection={removeQuestionSelection}
                errors={questionErrors}
                questionTypes={questionTypes}
                onAnswerChange={onAnswerChange}
                addAnswerOption={addAnswerOption}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <ButtonContainer center spaced>
                <a href={!_.isEmpty(survey.id) ? `/surveys/${survey.id}` : `/surveys`} className="button button--outline">
                Cancel
                </a>
                <Button onClick={() => submit()} disabled={submitDisabled}>
                  {submitText}
                </Button>
              </ButtonContainer>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

SurveyForm.propTypes = {
  survey: PropTypes.shape({}).isRequired,
  paths: PropTypes.shape({
    // This is not named as per rails generated routes because there are two depending on edit/new
    requestPath: PropTypes.string.isRequired
  }).isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  questionTypes: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default SurveyForm
